import React, { Component } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import projectStore from "../../stores/projectStore";
import { observer } from "mobx-react";
import { LuPencil, LuTrash } from "react-icons/lu";
import { PiWarningCircleFill } from "react-icons/pi";
import Button from "../../components/Button";
import { AddNewTalentColoredIcon } from "../../assets/icons";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    return <Component {...props} location={location} params={params} />;
  };
}

const Projects = observer(
  class Projects extends Component {
    constructor(props) {
      super(props);
      this.state = {
        limit: 5,
        showDeleteModal: false,
        deleteProject: null,
        showEditModal: false,
        editProject: null,
      };
    }

    componentDidMount() {
      const { clientName, year } = this.props.params;
      projectStore.getProjects({ clientName, year, limit: this.state.limit });
    }

    toggleDeleteModal = (deleteProject = null) => {
      this.setState({
        showDeleteModal: !this.state.showDeleteModal,
        deleteProject,
      });
    };

    handleDelete = () => {
      const { deleteProject } = this.state;
      if (deleteProject) {
        console.log("Deleting project", deleteProject);
        projectStore.deleteProject(deleteProject).then(() => {
          this.setState({ showDeleteModal: false });
          projectStore.getProjects(deleteProject);
        });
      }
    };

    toggleEditModal = (editProject = null) => {
      this.setState({
        showEditModal: !this.state.showEditModal,
        editProject: editProject,
      });
    };

    handleSave = () => {
      const { editProject } = this.state;
      if (editProject) {
        this.setState({ showEditModal: false });
      }
    };

    render() {
      const { year, clientName } = this.props.params;
      const { showEditModal, showDeleteModal, editProject } = this.state;
      console.log(this.props.params.clientName);
      

      return (
        <div className="flex flex-col p-8 bg-white flex-1 h-screen">
          <div className="flex flex-row justify-between mb-8 items-center">
            <div>
              <Link to={`/projects`}>Projects</Link>
              <span>{" > "}</span>
              <Link to={`/projects/${year}`}>{year}</Link>
              <span>{" > "}</span>
              <span className="font-bold">{clientName}</span>
            </div>

            {/* Add Button */}
            <div className="flex justify-end mx-6 gap-3 lg:gap-6">
              {/* Desktop Button */}
              <Button
                className="hidden md:flex rounded-md"
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true, {
                    clientName: this.props.params.clientName,
                    year: this.props.params.year,
                  });
                }}
                icon={AddNewTalentColoredIcon}
                title={"Add New"}
              />
              {/* Mobile Button */}
              <Button
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true);
                }}
                className="flex md:hidden rounded-md"
                icon={AddNewTalentColoredIcon}
              />
            </div>
          </div>

          {projectStore.projects && (
            <div className="flex justify-center lg:justify-start flex-row flex-wrap gap-12 items-end">
              {projectStore.projects.map((project, index) => {
                return (
                  <div
                    key={project.project_id + index}
                    className="flex relative overflow-hidden border-[3px]  border-[#F89A1F] rounded-xl text-[#130D0D] group hover:bg-[#f89a1f] hover:border-[#F89A1F] transition-all duration-100"
                  >
                    <Link
                      to={`/projects/${year}/${clientName}/${project.project_id}`}
                      className="flex relative overflow-hidden px-10 py-6 lg:px-16 lg:py-8"
                    >
                      <span
                        key={index}
                        className="font-medium text-xl text-[#130D0D] group-hover:text-white "
                      >
                        {project.project_name}
                      </span>
                    </Link>
                    <button
                      onClick={() =>
                        this.toggleDeleteModal({
                          clientName,
                          projectId: project.project_id,
                          projectYear: year,
                        })
                      }
                      className="cursor-pointer absolute top-0 right-0 lg:top-0 lg:right-0 p-2 bg-[#f89a1f] rounded-bl-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuTrash />
                    </button>
                    <button
                      onClick={() =>
                        this.toggleEditModal({
                          clientName,
                          projectId: project.project_id,
                          projectYear: year,
                          projectName: project.project_name,
                        })
                      }
                      className="cursor-pointer absolute bottom-0 lg:bottom-auto lg:top-0 right-0 lg:right-9 p-2 bg-[#f89a1f] rounded-tl-xl lg:rounded-tl-none lg:rounded-b-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuPencil />
                    </button>
                  </div>
                );
              })}

              <button
                onClick={() => {
                  this.setState({ limit: this.state.limit + 5 });
                  projectStore.getProjects({
                    clientName,
                    year,
                    limit: this.state.limit + 5,
                  });
                }}
                className="px-4 h-10 lg:px-8 lg:h-12 rounded-xl text-[#130D0D] bg-[#F89A1F] lg:hover:border-[#F89A1F] transition-all"
              >
                <span className="font-medium text-lg text-white">
                  Show More...
                </span>
              </button>
            </div>
          )}

          {/* Delete Modal */}
          {showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this project?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={this.handleDelete}
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Edit Modal */}
          {showEditModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <h3 className="text-lg font-semibold mb-4">
                  Update Project Name
                </h3>

                <div className="mb-4">
                  <input
                    type="text"
                    value={editProject.projectName}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        editProject: {
                          ...prevState.editProject,
                          projectName: e.target.value,
                        },
                      }));
                    }}
                    className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                  />
                </div>

                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleEditModal}
                    className="border border-gray-300 bg-white px-3 py-2 rounded-xl"
                  >
                    Cancel
                  </button>
                  <Button onClick={this.handleSave} title="Update"></Button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

export default withRouter(Projects);
